export default "__VITE_ASSET__0a7e7572__"